const colors = {
    primary: '#6060B8',
    secondary: '#6060B8',
    yes: '#7EB627',
    no: '#DF855F',
    pnc: '#929292',
    newPrimary: '#6060B8',
    newSecondary: '#E4E3ED',
    presentiel: '#E39393',
    virtuel: '#9AC657',
    light_purple:"#9DA4C8 ",
    dark_grey:"#484848",
    purple_blue:"#5048E5"
  };
  
  export default colors;
  